// 声明状态
export default {
    // 侧边导航收起展开控制状态 0 展开  1收起
    shouQ: false,
    // 头部导航联通  1 联通  2分开 ‘切换主题的控制’
    tong: 0,
    //个人工作台-类型选择
    type: 0,
    // 导航红点
    redD: {},
    //待办提醒
    apiList: [],
    //皮肤
    theme:1,
    //项目驱动
    projectDriver:[
      {
        title:'业务操作',
        son:[
        ]
      }
    ],
    //主菜单菜单
    projectMenu: [],
  projectId: 0,
  content: "",
  companyIds:[],
 }


// WEBPACK FOOTER //
// ./src/vuex/state.js